export const FETCH_SOLICITUDES_CREDITOS_REQUEST = 'FETCH_SOLICITUDES_CREDITOS_REQUEST'
export const FETCH_SOLICITUDES_CREDITOS_SUCCESS = 'FETCH_SOLICITUDES_CREDITOS_SUCCESS'
export const FETCH_SOLICITUDES_CREDITOS_ERROR = 'FETCH_SOLICITUDES_CREDITOS_ERROR'

export const FETCH_SOLICITUD_CREDITO_REQUEST = 'FETCH_SOLICITUD_CREDITO_REQUEST'
export const FETCH_SOLICITUD_CREDITO_SUCCESS = 'FETCH_SOLICITUD_CREDITO_SUCCESS'
export const STOP_LOADING_MODAL = 'STOP_LOADING_MODAL'
export const FETCH_SOLICITUD_CREDITO_ERROR = 'FETCH_SOLICITUD_CREDITO_ERROR'
export const CLEAR_SOLICITUD_CREDITO = 'CLEAR_SOLICITUD_CREDITO'

export const ASSIGN_SOLICITUD_CREDITO_ERROR = 'ASSIGN_SOLICITUD_CREDITO_ERROR'
export const ASSIGN_SOLICITUD_CREDITO_REQUEST = 'ASSIGN_SOLICITUD_CREDITO_REQUEST'
export const ASSIGN_SOLICITUD_CREDITO_SUCCESS = 'ASSIGN_SOLICITUD_CREDITO_SUCCESS'

export const UNLOCK_SOLICITUD_CREDITO_ERROR = 'UNLOCK_SOLICITUD_CREDITO_ERROR'
export const UNLOCK_SOLICITUD_CREDITO_REQUEST = 'UNLOCK_SOLICITUD_CREDITO_REQUEST'
export const UNLOCK_SOLICITUD_CREDITO_SUCCESS = 'UNLOCK_SOLICITUD_CREDITO_SUCCESS'

export const FETCH_MOTIVOS_RECHAZO_FILE_SUCCESS = 'FETCH_MOTIVOS_RECHAZO_FILE_SUCCESS'
export const FETCH_MOTIVOS_RECHAZO_FILE_ERROR = 'FETCH_MOTIVOS_RECHAZO_FILE_ERROR'

export const FETCH_MOTIVOS_RECHAZO_SOLICITUD_SUCCESS = 'FETCH_MOTIVOS_RECHAZO_SOLICITUD_SUCCESS'
export const FETCH_MOTIVOS_RECHAZO_SOLICITUD_ERROR = 'FETCH_MOTIVOS_RECHAZO_SOLICITUD_ERROR'

export const FETCH_FILE_REVIEW_SUCCESS = 'FETCH_FILE_REVIEW_SUCCESS'
export const FETCH_FILE_REVIEW_ERROR = 'FETCH_FILE_REVIEW_ERROR'

export const SHOW_MODAL_SOLICITUD = 'SHOW_MODAL_SOLICITUD'
export const CLOSE_MODAL_SOLICITUD = 'CLOSE_MODAL_SOLICITUD'

export const SEND_ID_OFERTA_SUCCESS = 'SEND_ID_OFERTA_SUCCESS'
export const SEND_ID_OFERTA_ERROR = 'SEND_ID_OFERTA_ERROR'

export const FETCH_REJECT_SOLICITUD_CREDITO_SUCCESS = 'FETCH_REJECT_SOLICITUD_CREDITO_SUCCESS'
export const FETCH_REJECT_SOLICITUD_CREDITO_ERROR = 'FETCH_REJECT_SOLICITUD_CREDITO_ERROR'

export const CHANGE_TO_DOCUMENTS_READY_SUCCESS = 'CHANGE_TO_DOCUMENTS_READY_SUCCESS'
export const CHANGE_TO_DOCUMENTS_READY_ERROR = 'CHANGE_TO_DOCUMENTS_READY_ERROR'

export const CHANGE_TO_ACTIVATE_CREDIT_SUCCESS = 'CHANGE_TO_ACTIVATE_CREDIT_SUCCESS'
export const CHANGE_TO_ACTIVATE_CREDIT_ERROR = 'CHANGE_TO_ACTIVATE_CREDIT_ERROR'

export const RESET_ID_OFERTA_ERROR = "RESET_ID_OFERTA_ERROR"
